import React from "react";
import { Link, useLocation } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { NAV } from "./Navbar";

function sectionFor(pathname) {
  const path = pathname.toLowerCase();
  for (const item of NAV) {
    if (!item.groups) continue;
    for (const group of item.groups) {
      if (group.links.some(([, to]) => to.toLowerCase() === path)) return item.title;
    }
  }
  return null;
}

function titleCase(text) {
  if (!text) return text;
  const lower = text.toLowerCase();
  if (text !== text.toUpperCase()) return text;
  return lower.replace(/\b([a-z])/g, (m) => m.toUpperCase()).replace(/\b(Ib|Tis|Myp|Pyp|Dp|Cas)\b/g, (m) => m.toUpperCase());
}

/** Page header band used by all content pages. */
const Hero = ({ title, tagLine }) => {
  const { pathname } = useLocation();
  const section = sectionFor(pathname);
  const heading = titleCase(title);
  return (
    <section className="relative isolate overflow-hidden bg-navy-800 text-white">
      <div
        className="absolute inset-0 -z-10 opacity-[0.07]"
        style={{
          backgroundImage:
            "radial-gradient(circle at 1px 1px, #fff 1px, transparent 0), linear-gradient(135deg, transparent 49%, #f6c612 50%, transparent 51%)",
          backgroundSize: "22px 22px, 120px 120px",
        }}
        aria-hidden
      />
      <div className="absolute -right-24 -top-24 -z-10 h-72 w-72 rounded-full bg-gold-400/20 blur-3xl" aria-hidden />
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 md:py-16">
        <nav aria-label="Breadcrumb" className="flex flex-wrap items-center gap-1.5 text-sm text-navy-200">
          <Link to="/" className="hover:text-white">
            Home
          </Link>
          {section && section.toLowerCase() !== (heading || "").toLowerCase() && (
            <>
              <ChevronRight className="h-3.5 w-3.5" aria-hidden />
              <span>{section}</span>
            </>
          )}
          <ChevronRight className="h-3.5 w-3.5" aria-hidden />
          <span className="font-semibold text-gold-300">{heading}</span>
        </nav>
        <h1 className="mt-4 max-w-4xl font-display text-3xl font-extrabold leading-tight sm:text-4xl md:text-5xl">{heading}</h1>
        {tagLine && <p className="mt-3 max-w-3xl text-lg text-navy-100">{tagLine}</p>}
        <div className="mt-6 h-1 w-20 rounded bg-gold-400" aria-hidden />
      </div>
    </section>
  );
};

export default Hero;
